import { CardProps } from "./types";

export const CardWithRadio = ({ title, description, onSelect, checked, id }: CardProps) => (
  <div
    className={`flex cursor-pointer select-none items-start gap-4 rounded-lg border p-4 transition-all duration-200 ease-in-out hover:border-blue-400 hover:bg-gray-50 hover:shadow-md active:border-blue-500 ${
      checked ? "border-blue-500" : "border-gray-200"
    }`}
    onClick={() => onSelect(id)}
  >
    <label className="mt-1 flex cursor-pointer items-center transition-all duration-200 ease-in-out">
      <input
        type="radio"
        value={id}
        checked={checked}
        onChange={() => onSelect(id)}
        className="hidden"
      />
      <span
        className={`h-4 w-4 rounded-full border transition-all duration-200 ease-in-out ${
          checked ? "border-blue-500 bg-blue-50" : "border-gray-300 bg-white"
        }`}
      >
        {checked && (
          <div className="relative flex h-full w-full items-center justify-center after:block after:h-1.5 after:w-1.5 after:rounded-full after:bg-blue-500 after:transition-all after:duration-200 after:ease-in-out" />
        )}
      </span>
    </label>
    <div className="flex flex-col justify-center transition-colors duration-200 ease-in-out">
      <div className="text-base font-bold text-gray-900 transition-colors duration-200 ease-in-out">
        {title}
      </div>
      <div className="text-sm text-gray-600 transition-colors duration-200 ease-in-out">
        {description}
      </div>
    </div>
  </div>
);
